<template>
  <div>
    <el-row :gutter="20">
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" ref="searchForm" size="medium">
          <el-form-item label="调拨日期：">
            <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select filterable v-model="searchForm.STATUS" clearable placeholder="请选择">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-if="activeName == 'adjust_out'" filterable v-model="searchForm.DEST_GYS_ID" clearable placeholder="请选择">
              <el-option v-for="item in PROJECT_LIST" :key="item.DEST_GYS_ID" :label="item.NAME" :value="item.DEST_GYS_ID"></el-option>
            </el-select>
            <el-select v-else filterable v-model="searchForm.DEST_GYS_ID" clearable placeholder="请选择">
              <el-option v-for="item in GYS_LIST" :key="item.DEST_GYS_ID" :label="item.NAME" :value="item.DEST_GYS_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-button @click="search" type="primary">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row v-if="activeName == 'adjust_out'">
      <el-col>
        <el-button @click="createDocument" size="medium">创建调拨单</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" style="margin-top: 20px;">
        <el-tab-pane label="调拨出库" name="adjust_out" lazy>
          <V-AdjustOut ref="adjust_out" :search-form1="searchForm" @getProjectList="getProjectList($event)">
          </V-AdjustOut>
        </el-tab-pane>
        <el-tab-pane label="调拨入库" name="adjust_enter" lazy>
          <V-AdjustEnter ref="adjust_enter" :search-form1="searchForm" @getGYSList="getGYSList($event)">
          </V-AdjustEnter>
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>
<script>
import VAdjustOut from './adjust_out';
import VAdjustEnter from './adjust_enter';

export default {
  data() {
    return {
      activeName: 'adjust_out',
      tabActiveName: sessionStorage.getItem('adjustTabActiveName'),
      active: ['adjust_out', 'adjust_enter'],
      searchForm: {},
      statusList: [
        {
          label: '已撤回',
          value: '0',
        },
        {
          label: '未处理',
          value: '1',
        },
        {
          label: '已同意',
          value: '2',
        },
      ],
      PROJECT_LIST: [],
      GYS_LIST: [],
    };
  },
  components: {
    VAdjustOut,
    VAdjustEnter,
  },
  created() {
    this.tabActive();
  },
  mounted() {
    this.handleClick();
  },
  methods: {
    handleClick(tab, event) {
      sessionStorage.setItem('adjustTabActiveName', this.activeName);
    },
    tabActive() {
      const flag = this.active.find((item) => {
        if (this.tabActiveName == item) {
          return true;
        }
      });
      if (flag) {
        this.activeName = this.tabActiveName;
      }
    },
    getProjectList(data) {
      this.PROJECT_LIST = data;
    },
    getGYSList(data) {
      this.GYS_LIST = data;
    },
    createDocument() {
      this.$refs.adjust_out.createDocument();
    },
    search() {
      if (this.activeName == 'adjust_out') {
        this.$refs.adjust_out.search();
      } else {
        this.$refs.adjust_enter.search();
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/adjust.vue